export const headerHeight = 1;
export const featuredMemorials =
   process.env.NODE_ENV === "production" ? ["10", "3", "4", "5"] : ["161", "162", "163"];
